module.exports = __webpack_public_path__ + "img/m4.a0b2aa6.jpg";